import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, Row } from "react-bootstrap";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomPhoneInput from "../../../CustomControls/CustomPhoneInput";
import { post } from "../../../helpers/api_helper";
import swal from "sweetalert";
import { Spin } from "antd";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import {
  POST_CourierInsert,
  POST_CourierUpdate,
  POST_GetCourierDetailByID,
} from "../../../helpers/url_helper";
import {
  successMessage,
  errorMessage,
  validateEmailField,
  validateMobileNoField,
  capitalizeString,
} from "../CommonFunctions";

const AddCourier = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam } = useParams();

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const validationSchema = Yup.object().shape({
    CourierName: Yup.string().trim().required("Courier Name is required field"),
    // CourierAddress: Yup.string()
    //   .trim()
    //   .required("Courier Address is required field"),
    // MobileNo: Yup.string().required("Mobile No is required field"),
    // EmailID: Yup.string().trim().required("Email is required field"),
    // ContactPersonName: Yup.string()
    //   .trim()
    //   .required("Contact Person Name is required field"),
    // WebLink: Yup.string().trim().required("Web Link is required field"),
  });

  useEffect(() => {
    if (PrimaryIdParam) {
      getCourierDetailsByID();
    }
  }, []);

  const getCourierDetailsByID = () => {
    setIsLoading(true);
    post(POST_GetCourierDetailByID, {
      CourierIDEncrypted: window.atob(PrimaryIdParam),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setValues({
            ...response,
          });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      CourierIDEncrypted: PrimaryIdParam ? window.atob(PrimaryIdParam) : "",
      CourierName: "",
      CourierAddress: "",
      CountryCode: "+91",
      MobileNo: "",
      MobileNoFormat: "",
      EmailID: "",
      ContactPersonName: "",
      WebLink: "",
    },
    validateOnBlur: false,
  });

  const {
    setFieldValue,
    values: { CountryCode },
  } = formik;

  const handleValidSubmit = (values) => {
    if (
      !validateMobileNoField(
        values?.MobileNoFormat,
        CountryCode,
        values?.MobileNo,
      )
    ) {
      formik.setFieldError("MobileNo", "Please enter a valid mobile number");
      formik.setFieldTouched("MobileNo", true);
      return false;
    }
    setIsLoading(true);

    let payload = {
      ...values,
      CourierName: values.CourierName.trim(),
      CourierAddress: values.CourierAddress.trim(),
      EmailID: values.EmailID.trim(),
      ContactPersonName: values.ContactPersonName.trim(),
      WebLink: values.WebLink.trim(),
      CountryCode: "+" + CountryCode.replace(/\+/g, ""),
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };

    post(PrimaryIdParam ? POST_CourierUpdate : POST_CourierInsert, payload)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          // swal("Success!", response?.Message, "success");
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/courier");
          }, 1000);
        } else {
          // swal("Error!", response?.Message, "error");
          errorMessage(response?.Message);
          setIsLoading(false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">
                {PrimaryIdParam ? "Edit" : "Add"} Courier
              </h4>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0">
              <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                  <Row>
                    <Col lg={3}>
                      <Field
                        label="Courier Name"
                        name="CourierName"
                        placeholder={"Enter Courier Name"}
                        component={CustomInput}
                        required
                        maxLength={250}
                        autoFocus
                        onChange={(e) => {
                          formik.setFieldValue(
                            "CourierName",
                            capitalizeString(e?.target?.value),
                          );
                        }}
                      />
                    </Col>

                    <Col lg={3}>
                      <Field
                        label="Contact Person Name"
                        name="ContactPersonName"
                        placeholder={"Enter Contact Person Name"}
                        component={CustomInput}
                        maxLength={150}
                        // required
                        onChange={(e) => {
                          formik.setFieldValue(
                            "ContactPersonName",
                            capitalizeString(e?.target?.value),
                          );
                        }}
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        type="text"
                        label={"Mobile No."}
                        name="MobileNo"
                        placeholder={"Enter Mobile No."}
                        countryCode={CountryCode}
                        component={CustomPhoneInput}
                        onChange={(value, { countryCode, dialCode }) => {
                          setFieldValue("CountryCode", dialCode);
                          setFieldValue(
                            "MobileNo",
                            value.substring(dialCode.toString().length),
                          );
                        }}
                        onFocus={(value, { format }) => {
                          setFieldValue("MobileNoFormat", format);
                        }}
                        // required
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        type="email"
                        label={"Email"}
                        name="EmailID"
                        placeholder={"Enter Email"}
                        component={CustomInput}
                        maxLength={100}
                        // required
                        validate={validateEmailField}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={9}>
                      <Row>
                        <Col lg={4}>
                          <Field
                            label="Address"
                            name="CourierAddress"
                            rows={5}
                            placeholder={"Enter Address"}
                            component={CustomTextArea}
                            maxLength={500}
                            // required
                          />
                        </Col>
                        <Col lg={8}>
                          <Row>
                            <Col lg={6}>
                              <Field
                                label="Web Link"
                                name="WebLink"
                                placeholder={"Enter WebLink"}
                                component={CustomInput}
                                maxLength={500}
                                // required
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={3}></Col>
                  </Row>
                  <hr className="mt-1 mb-2"></hr>
                  <button
                    type="submit"
                    // className="btn btn-primary"
                    className="btn btn-primary btn-sm me-2"
                  >
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </button>
                  <button
                    type="button"
                    // className="btn btn-danger light"
                    className="btn btn-danger btn-sm"
                    onClick={(e) => {
                      navigate(-1);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                </Form>
              </FormikProvider>
            </div>
          </Spin>
        </div>
      </div>
    </>
  );
};

export default AddCourier;
